import { Alert, Button, Collapse } from "@mantine/core";
import * as React from "react";
import RosterAdministrator, { IRosterAdministratorProps } from "./RosterAdministrator";

interface RosterSupervisorCollapseProps extends IRosterAdministratorProps {
  defaultIsOpen?: boolean;
  shiftId: string;
  sessionId: string;
  venueId: string;

  showHideAppointmentFromSheetButton: boolean
}

const RosterAdministratorCollapse: React.FunctionComponent<
  RosterSupervisorCollapseProps
> = ({ defaultIsOpen, ...other }) => {
  const [isOpen, toggle] = React.useState(
    defaultIsOpen !== undefined ? defaultIsOpen : false,
  );

  return (
    <div>
      <p style={{ float: "left", marginBottom: "0px" }}>
        <b>Administrators</b>
      </p>
      <Button
        onClick={() => toggle(!isOpen)}
        style={{ float: "right", marginLeft: "100px" }}
        size="sm"
        variant="outline"
        color="blue"
      >
        {isOpen ? "Close" : "Open"}
      </Button>
      {isOpen && <br />}
      <Collapse in={isOpen}>
        <div style={{ marginTop: "16px" }}>
          <Alert color="blue">
            <strong>Note:</strong> This will use the administrator rate set ON a person's association.
            To modify this rate you'll need to add a new association in the <a href="/admin/persons" target="_blank">Person editor</a>.
            <br /><br />
            Adding an administration appointment does NOT affect a person's availability.
          </Alert>
          <RosterAdministrator {...other} />
        </div>
      </Collapse>
    </div>
  );
};

export default RosterAdministratorCollapse;
